import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { times } from 'lodash';
import React from 'react';

import { TeachingUnitEntrySkeleton } from '../TeachingUnitEntry/TeachingUnitEntrySkeleton';
import './CurrentLessonCard.scss';

export const CurrentLessonCardSkeleton: React.FC = () => {
  return (
    <Skeleton>
      <div className="card currentLessonCardSkeleton">
        <div className="cardHead">
          <SkeletonItem className="cardHeadSkeletonLine" />
        </div>
        {times(2, () => (
          <TeachingUnitEntrySkeleton />
        ))}
      </div>
    </Skeleton>
  );
};
